module.exports = __webpack_public_path__ + "media/audios/kid/lesson_8/audio_tpc8_pedrinha-d1789f6962c4527c86b387fd675cca4c.m4a";